import React from 'react';
import * as S from './styles';

type Props = {
  children?: React.ReactNode;
  containerProps?: {};
  onMount?: () => void;
  wrap?: boolean;
  wrapMobile?: boolean;
};

export const Pillbox = (props: Props) => {
  const { children, wrap = true, wrapMobile = true, containerProps } = props;

  return (
    <S.StyledPillbox $wrap={wrap} $wrapMobile={wrapMobile} {...containerProps}>
      {children}
    </S.StyledPillbox>
  );
};
